import {
    BULKUPDATESTATUSPARTNER_SUCCESS,
    BULKUPDATESTATUSPARTNER_FAILED,
    RESET_BULKUPDATESTATUSPARTNER,
    LOADING_BULKUPDATESTATUSPARTNER,
    NETWORK_ERROR_BULKUPDATESTATUSPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BULKUPDATESTATUSPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BULKUPDATESTATUSPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BULKUPDATESTATUSPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_BULKUPDATESTATUSPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BULKUPDATESTATUSPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};